import { render, staticRenderFns } from "./detailsResult.vue?vue&type=template&id=395d121c&scoped=true&"
import script from "./detailsResult.vue?vue&type=script&lang=js&"
export * from "./detailsResult.vue?vue&type=script&lang=js&"
import style0 from "./detailsResult.vue?vue&type=style&index=0&id=395d121c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395d121c",
  null
  
)

export default component.exports